import { render, staticRenderFns } from "./DetailPianoTerapeutico.vue?vue&type=template&id=097efc9e&"
import script from "./DetailPianoTerapeutico.vue?vue&type=script&lang=js&"
export * from "./DetailPianoTerapeutico.vue?vue&type=script&lang=js&"
import style0 from "./DetailPianoTerapeutico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports